import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgFlash({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.205 14.04a1.201 1.201 0 01-.767-1.938l7.323-9.155a1.2 1.2 0 012.125.92l-.755 5.284 5.664.81a1.2 1.2 0 01.767 1.937l-7.323 9.154a1.2 1.2 0 01-2.125-.919l.755-5.285-5.664-.809zm6.287-7.554l-4.618 5.772 4.772.681a1.5 1.5 0 011.273 1.697l-.41 2.878 4.616-5.772-4.771-.681a1.5 1.5 0 01-1.273-1.697l.41-2.878z"
        fill={color}
      />
    </svg>
  )
}

export default SvgFlash
